export enum ProjectItemStatus {
  valid = 'VALID',
  invalid = 'INVALID'
}
